/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

//import axios from '@/axios.js';
import firebase from '@/services/saleData';
import 'firebase/database';
import 'firebase/storage';
import moment from "moment-timezone";
import _ from 'lodash';
export default {
  // addItem({ commit }, item) {
  //   return new Promise((resolve, reject) => {
  //     axios.post("/api/data-list/products/", {item: item})
  //       .then((response) => {
  //         commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  
  async fetchMasters ({ commit }) {
    //const data = localStorage.getItem('userInfo');
    //const user = JSON.parse(data);
    /*if (user.company === undefined || user.company === '') {
      await firebase.auth().signOut().then(() => {
        router.push('/login').catch(() => {})
      });
    }*/
    const user = (await firebase.database().ref(`/users`).once('value')).val();
    const usersdata = [];
    for(const x in user){
      if(usersdata[user[x].master] === undefined) {
        usersdata[user[x].master] = 0;
      }
      usersdata[user[x].master]++;
    }
    const agent = (await firebase.database().ref(`/agents`).once('value')).val();
    
    const agents = [];
    const agents2 = [];
    for(const x in agent){
      agents[x] = agent[x];
      agents2.push({
        key:x,
        name:agent[x].name
      });
    }
    commit('SET_AGENTS', agents2);
    firebase.database().ref().child('master').once('value', (snapshot) => {
      let users = []; 
      snapshot.forEach((data) => {
        const user = data.val();
        user.key = data.key;
        user.agent = (agents[user.agent])?agents[user.agent].name:'';
        user.user_count = (usersdata[data.key])?usersdata[data.key]:0;
        //user.lineurl = "https://liff.line.me/1654386029-X0V1ywVe/register/?uid="+data.key;
        user.lineurl = "http://ufaeasy888.com/line.html?uid="+data.key;
        console.log(user.lineurl);
        users.push(user);
      });
      users = _.orderBy(users, ['createdate'],['desc']);
      commit('SET_MASTERS', users);
    });
  },
  async saveMaster({state,commit,dispatch}){
    if(state.master.key){
      firebase.database().ref(`master/${state.master.key}`).update({
        name:state.master.name,
        agent:state.master.agent,
        createdate:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss")
      });
    }else{
      const masters = (await firebase.database().ref(`/master`).once('value')).val();
      let max = 0;
      for(const x in masters){
        max = x;
      }
      
      firebase.database().ref('master/'+(Number(max)+1)).set({
        name:state.master.name,
        agent:state.master.agent,
        createdate:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss")
      });
    }
    dispatch('fetchMasters');
    commit('SET_MASTER',{
      key:'',
      name:'',
      agent:'',
    });
    commit('SET_POPUP',false);
  },
}
